import { EditInlineDialogProps } from "components/Actions/dialogs/types";
import { GROUP_ACTIONS } from "components/Actions/types";

import ManageGroup from "../../ManageGroup";

const EditGroupInline = ({ data, isOpen, close }: EditInlineDialogProps) => {
    return (
        <ManageGroup
            action={GROUP_ACTIONS.EditGroup}
            isOpen={isOpen}
            rowData={data}
            close={close}
        />
    );
};

export default EditGroupInline;
